<template>
  <div class="container">
    <div class="header">
      <h2>FACILITY</h2>
    </div>
    <div class="cateMainItemContainer">
      <div class="leftContainer">
        <div class="itemThumb"></div>
        <div class="colSpace"></div>
      </div>
      <div :class="{jpword: isLang === 2}">
        <div class="rightContainer">
          <div :class="{anotherword: isLang === 0 || isLang === 1}">
            <div class="introDescription">{{ $t('main_facility_desc1') }}</div>
            <div class="mainTitle">HOTSPRING</div>
            <hr class="mainTitleUnderline" />
            <div class="detailDescription">
              <div class="detailDescText" style="font-size: 0.99rem">
                {{ $t('main_facility_desc2') }}
              </div>
              <div class="detailDescText">{{ $t('main_facility_desc3') }}</div>
              <div class="detailDescText">{{ $t('main_facility_desc4') }}</div>
              <div class="rowSpace"></div>
              <div class="buttonGroup">
                <button class="moveButton" @click="goLink('Aragonite')">
                  <span>{{ $t('main_facility_link') }}</span>
                  <div class="colSpace"></div>
                  <b-icon icon="chevron-right" font-scale="1" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rowSpace"></div>
    <FacilitySubItems />
  </div>
</template>

<script>
import FacilitySubItems from '@/pages/MainPage/Components/FacilitySubItems';

export default {
  name: 'FacilityMainItem',
  components: {
    FacilitySubItems,
  },
  methods: {
    goLink(url) {
      console.log('go');
      this.$router.push('p/' + url);
    },
  },
};
</script>

<style scoped lang="scss">
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  td {
    word-break: keep-all;
  }
}
h2 {
  padding-top: 3rem;
  padding-bottom: 3rem;
  height: 8rem;
  text-align: center;
  color: #222222;
  font-family: 'Jeju Myeongjo', sans-serif;
  font-weight: 700;
}
.header {
  display: flex;
  justify-content: center;
  h4 {
    text-align: center;
    color: #222222;
    opacity: 1;
    font-size: 2rem;
    font-weight: 700;
    margin-top: 2rem;
  }
}
.cateMainItemContainer {
  display: flex;
  border: 1px solid #e2e2e2;
  padding: 2rem;
}
.leftContainer {
  display: flex;
}
.rightContainer {
  align-self: center;
}
.itemThumb {
  background-image: url('~@/assets/images/Annex/annex-facility-thumb-large.jpg');
  width: 20rem;
  height: 20rem;
  display: inline-block;
  object-fit: cover;
  object-position: top;
}
.introDescription {
  text-align: left;
  letter-spacing: -0.02rem;
  color: #828282;
  font-size: 1rem;
  font-weight: 600;
}
.mainTitle {
  text-align: left;
  letter-spacing: 0px;
  color: #27888f;
  font-size: 2rem;
  font-weight: 600;
}
.mainTitleUnderline {
  text-align: left;
  width: 3rem;
  border: solid 1px #27888f;
  margin-left: 0rem;
}
.detailDescription {
  display: table-cell;
}
.detailDescText {
  text-align: left;
  font-family: 'Nunito', sans-serif;
  font-weight: 500;
  letter-spacing: -0.02rem;
  line-height: 2rem;
  color: #363636;
  opacity: 1;
}
.buttonGroup {
  display: flex;
  width: 100%;
  .moveButton {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
    font-size: 1rem;
    font-weight: 600;
    width: 40%;
    background-color: #524a3d !important;
    padding: 0px !important;
    color: white;
    border: none;
    outline: none;
    span {
      padding: 0px;
      text-align: center;
      padding: 0px !important;
    }
    &:hover {
      background-color: #403a30 !important;
    }
  }
}

.colSpace {
  width: 2rem;
}
.rowSpace {
  height: 2rem;
}

@media (max-width: 992px) {
  .cateMainItemContainer {
    display: block;
    border: 1px solid #e2e2e2;
    padding: 2rem;
  }
  .leftContainer {
    display: flex;
  }
  .rightContainer {
    align-self: center;
  }

  .colSpace {
    width: 0rem;
  }
}
</style>

<i18n>
{
  "ko": {
    "main_facility_desc1": "순백의 눈처럼 하얀, 국내 유일 온천수 '아라고나이트'",
    "main_facility_desc2": "국내유일의 온천수, 아라고나이트가 선사하는 건강한 에너지를 느껴보세요.",
    "main_facility_desc3": "한라산 깊이보다 깊은 2001.3m에서 끌어올린 42°C 고온천이",
    "main_facility_desc4": "몸과 마음의 피로를 녹여줍니다.",
    "main_facility_link": "바로가기"
  },
  "en": {
    "main_facility_desc1": "the one and only hot spring water as white as snow in Korea,",
    "main_facility_desc2": "Feel the healthy energy presented by aragonite, the only hot spring water",
    "main_facility_desc3": "in the country. The 42°C hot spring, raised from 2,001.3 m below, greater",
    "main_facility_desc4": "than the height of Hallasan Mountain, will relieve exhausted mind and body.",
    "main_facility_link": "Site link"
  },
  "ja": {
    "main_facility_desc1": "純白の雪のように白い韓国唯一の温泉水『アラゴナイト』",
    "main_facility_desc2": "韓国唯一の温泉水、アラゴナイトが贈る健康なエネルギーを感じてください。",
    "main_facility_desc3": "漢拏山の高さよりも深い地下2001.3ｍからくみ上げた42℃の",
    "main_facility_desc4": "高温泉が心と体の疲労をほぐします。",
    "main_facility_link": "サイトに移動"
  }
}
</i18n>
